export const ConvertUrlToFile = (
  blob: Blob,
  title: string,
  type: 'video' | 'image',
): File => {
  return new File(
    [blob as Blob],
    type === 'video' ? `${title}.mp4` : `${title}.jpeg`,
    {
      type: type === 'video' ? 'video/mp4' : 'image/jpeg',
    },
  );
};
